module.exports = __webpack_public_path__ + "static/KC13-e08db0c55d8fd82498f3b33daec095af.png";